var map = {
	"./Beth.Testimonial.Pic.jpeg": 3045,
	"./DylanChong.jpeg": 9830,
	"./Kayden and Makayla.Testimonial.Pic.jpeg": 3450,
	"./LisabelleLouisa.jpeg": 8674,
	"./Myrna.Testimonial.Pic.jpeg": 7253,
	"./Testimonial.parent.jpg": 5274,
	"./Testimonial.student.jpg": 4777,
	"./XinTing.jpeg": 1339,
	"./ZhiQian.jpeg": 2749
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7196;